import React, { Component } from 'react';

class WhyBook extends Component {
  render() {
    // let { brand } = this.props;
    // const perRoomCopy = (brand !== 'Sandals') ? '$98 per room' : '$49 per person';

    // brand = brand.split(' ').join('');

    return (
      <div className="row why-book">
        {/* <p className="sm-12">Why book with {brand.trim()}.com?</p>
        <div className="sm-12 md-8 md-offset-2">
          <ul className="row">
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Hold Booking For Only {perRoomCopy}</li>
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Best Offer Automatically Applied</li>
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Free Room Cancellation</li>
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Best Price Guarantee</li>
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Book Online And Get $25 Credit</li>
            <li className="d-flex sm-12 md-6"><i className="check">&#10004;</i> Book Flights &amp; Save On Travel Protection</li>
          </ul>
        </div> */}
      </div>
    );
  }
}

export default WhyBook;



// WEBPACK FOOTER //
// ./js/components/step1/WhyBook.js